export const checkHideInStoreForFamily = (productFamily: string, excludedProductFamilyForInStore: string) => {
  if (productFamily === '') return false;

  return excludedProductFamilyForInStore
    ?.split(',')
    .map(item => item.trim().toLowerCase())
    .includes(productFamily.toLowerCase());
};
